import { api, refresher } from '@/api'
import { createSessionService } from './session'

export const session = createSessionService({ api, refresher })

export { useSessionStore, getAccessToken } from './session-store'
export type { LogoutReason, SessionState, SessionStatus } from './session-store'
export type { RefreshOutcome } from './refresh'
export {
  useCan,
  useCanAll,
  useCapabilities,
  useLockedOut,
  hasPermission,
  hasAllPermissions,
  hasAnyPermission,
} from './capabilities'
export type { Permission } from './capabilities'
